import { render, staticRenderFns } from "./intended_work_canada.vue?vue&type=template&id=013f62cc&"
import script from "./intended_work_canada.vue?vue&type=script&lang=js&"
export * from "./intended_work_canada.vue?vue&type=script&lang=js&"
import style0 from "./intended_work_canada.vue?vue&type=style&index=0&id=013f62cc&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports